import { SectionHeader } from "common/components/SectionHeader";
import { LanguageContext } from "configuration/app-context-manager/LanguageContext";
import React, { useContext } from "react";
import Data from "./data/index.json";
import { Box, Container } from "@mui/material";
import { Info } from "./components/Info";
import { Map } from "./components/Map";
import Arrive from "./components/Arrive";

export const Contacts = () => {
  const { language } = useContext(LanguageContext);
  return (
    <Box>
      {/* Header */}
      <Box mt={10} mb={{ xs: 2, md: 4 }}>
        <SectionHeader
          title={Data[language].title}
          subtitle={Data[language].subtitle}
        />
      </Box>

      {/* Map - full bleed */}
      <Map />

      {/* Info cards */}
      <Box py={{ xs: 6, md: 10 }}>
        <Container
          maxWidth="lg"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: { xs: "center", md: "stretch" },
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 4, md: 5 },
          }}
        >
          {Data[language].info.map((inf, id) => (
            <Info key={id} data={inf} />
          ))}
        </Container>
      </Box>

      {/* How to arrive */}
      <Box
        py={{ xs: 6, md: 10 }}
        sx={{ backgroundColor: "var(--clr-warm-bg)" }}
      >
        <Arrive data={Data[language].arrive} />
      </Box>
    </Box>
  );
};
